import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from 'react-schemaorg'; 


const getDrawImage = (type) => { 
    switch (type) {
        case '1': return `${"https://gulfticket.com/assets/img/gamesBg/play-lotto.png"}`;
        case '2': return `${"https://gulfticket.com/assets/img/gamesBg/mini-lotto.png"}`;
        case '3': return `${"https://gulfticket.com/assets/img/gamesBg/fast-lotto.png"}`;
        case '4': return `${"https://gulfticket.com/assets/img/gamesBg/millionaire-lotto.png"}`;
        case '5': return `${"https://gulfticket.com/assets/img/gamesBg/muliti-millions-lotto.png?v0.8"}`;
        case '6': return `${"https://gulfticket.com/assets/img/gamesBg/super-mega-lotto.png?v0.8"}`;
    }
};

const getDrawTitle = (type) => {
    switch (type) {
        case '1': return 'playlotto Draw Tracker | Code Check and Winner Reveal | Gulf Ticket';
        case '2': return 'minilotto draw line and Winning Odds | Jackpot Updates This Week | Gulf Ticket';
        case '3': return 'fastlotto Game Outcome Today | Check Lucky Codes and Draw Picks | Gulf Ticket';
        case '4': return 'millionairelotto Daily Jackpot Results | Match Digits and Winning Status | Gulf Ticket';
        case '5': return 'multimillion Winning Numbers Today | Prize Chart and Claim Details | Gulf Ticket';
        case '6': return 'Rush3 Numbers Live Now | Result Breakdown and Instant Play Info | Gulf Ticket';
    }
};

const getDrawDescription = (type) => {
    switch (type) {
        case '1': return 'View today’s playlottoDraws live results, lucky numbers, and winners list. Follow Gulf Ticket for real-time draw updates and winning combinations.';
        case '2': return 'Catch today’s minilottoDraws results live. Check the draw time, winning numbers, and prize announcements instantly at Gulf Ticket.';
        case '3': return "Watch fastlottoDraws results and updates live. View today’s draw numbers, match your ticket, and see if you're one of Gulf Ticket’s lucky winners.";
        case '4': return 'Find the latest millionairelottoDraws results and winning numbers. Get real-time updates and prize details directly from Gulf Ticket’s official lottery page.';
        case '5': return 'Check multimillionDraws live results, winning numbers, and today’s lucky winners. Stay updated with Gulf Ticket’s latest draw outcomes and prize announcements.';
        case '6': return 'Access supermega million lotto live results and winning numbers online. Find today’s draw details and see if your Rush3 ticket is a winner with Gulf Ticket.';
    }
};


const GetDrawKeywords = (type) => {
    switch (type) {
        case '1': return 'Play Lotto lottery results';
        case '2': return 'Mini Lotto  lottery results';
        case '3': return "Fast Lotto lottery results";
        case '4': return 'Millionaire Lotto lottery results';
        case '5': return 'Multi Million Lotto lottery results';
        case '6': return 'Super Mega Million Lotto lottery results';
    }
};



function DrawsHelmetOthers({ drawType }) {
    let dd = [
        helmetJsonLdProp({
            "@context": "http://www.schema.org",
            "@graph": [
                {
                    "@type": "BreadcrumbList",
                    itemListElement: [{ "@type": "ListItem", "position": 1, "name": "Draws" }]
                },
                {
                    "@type": "WebSite",
                    name: "Gulf Ticket ",
                    alternateName: "Gulf Ticket India",
                    url: process.env.REACT_APP_DESKTOP_URL
                }]
        })
    ]
    return (
        <div>
            <Helmet script={dd}>
                <title>{getDrawTitle(drawType)}</title>
                <meta name="description" content={getDrawDescription(drawType)} />
                <meta name="keywords" content={GetDrawKeywords(drawType)} />
                <meta property="og:title" content={getDrawTitle(drawType)} />
                <meta property="og:image" content={getDrawImage(drawType)} />
                <meta property="og:site_name" content="Gulf Ticket" />
                <meta property="og:url" content={process.env.REACT_APP_DESKTOP_URL} />
                <meta property="og:description" content={getDrawDescription(drawType)} />
                <meta property="og:type" content="website" />
            </Helmet>
        </div>
    );
}

export default DrawsHelmetOthers;
